DEFAULT_EL = '.urgency-message > .timer #timer-clock'

window.UrgencyTimer ?= {}

UrgencyTimer.Helpers = require '../../common/helpers'

UrgencyTimer.View = Backbone.View.extend
  UPDATE_FREQUENCY_MS: 1000

  initialize: ->
    @i18n = @options.i18n
    @el = @options.el or DEFAULT_EL

  render: ->
    clearInterval @interval if @interval?
    @$el = $(@el)
    @interval = setInterval (=> @updateCountdown()), @UPDATE_FREQUENCY_MS

  updateCountdown: ->
    timeLeft = @model.timeLeft()
    countdownTime = @t "js.modules.groupon-deal-timer#{CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)}",
      days: timeLeft.days
      timerIcon: '<span class="icon-now"></span>'
      timestamp: UrgencyTimer.Helpers.countdownTimestamp timeLeft

    @$el.html countdownTime

  t: ->
    @i18n.t.apply @i18n, arguments


module.exports = UrgencyTimer.View
